<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.inn_id" placeholder="酒店ID" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.room_type_code" placeholder="房型编号" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.room_type_name" placeholder="房型名称" style="width: 220px;" clearable
                size="small"/>
      <el-button class="filter-item" type="primary" @click="handleFilter" size="small">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column label="ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.inn_id }}
        </template>
      </el-table-column>
      <el-table-column label="房型编号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type_code }}
        </template>
      </el-table-column>
      <el-table-column label="房型名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type_name||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="房型英文名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type_name_en||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="房型唯一编号" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.s_code||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="是否允许加床" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.add_bed === 0" type="warning">否</el-tag>
          <el-tag v-else-if="scope.row.add_bed === 1" type="success">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="面积" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.area||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="床数" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.bed_count||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="床型" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.bed_type === 1">双床</span>
          <span v-else-if="scope.row.bed_type === 2">单床</span>
          <span v-else-if="scope.row.bed_type === 0">大床</span>
          <span v-else-if="scope.row.bed_type === 101">其他床型</span>
        </template>
      </el-table-column>
      <el-table-column label="床宽" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.bed_width||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含有加床费" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.extra_bed_fee === 0" type="warning">否</el-tag>
          <el-tag v-else-if="scope.row.extra_bed_fee === 1" type="success">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="楼层" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.floor||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="最多入住人数" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.max_check_in||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="最大房间数量" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.max_room||"-" }}
        </template>
      </el-table-column>

      <el-table-column label="窗户" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.window === 0" type="warning">无窗</el-tag>
          <el-tag v-else-if="scope.row.window === 1" type="success">有窗</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

<!--      <el-table-column label="操作" width="250" align="center" fixed="right" class-name="small-padding fixed-width">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="warning" size="mini" @click="handleSalesRoomType(scope.row)">售卖房型</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          hotel_name: "",
          basic_room_type_name: "",
        },
      };
    },
    created() {
      this.getList();
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/hotel/hotelRoomTypeList",
          method: "get",
          params: this.listQuery,
        }).then(response => {
          this.list = response.data.items;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      // 售卖房型
      handleSalesRoomType(row) {
        this.$router.push(`/salesRoomTypeList?basic_room_type_id=${row.id}`);
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
